module.exports = __webpack_public_path__ + "static/media/bh.8932aa22.jpeg";